/* Aleefy TECH layer — glitch text, living hero, parallax details. */
(function () {
  'use strict';
  var d = document, w = window;
  function mq(q) { return w.matchMedia ? w.matchMedia(q).matches : false; }
  var reduce = mq('(prefers-reduced-motion: reduce)');
  var fine = mq('(hover: hover) and (pointer: fine)');
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  var hasIO = 'IntersectionObserver' in w;

  d.body.classList.add('tx');

  /* ---------- reveal ---------- */
  var rv = $$('.tx-rv');
  if (reduce || !hasIO) {
    rv.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var rio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); rio.unobserve(e.target); } });
    }, { threshold: 0.15 });
    rv.forEach(function (el) { rio.observe(el); });
    setTimeout(function () {
      rv.forEach(function (el) { if (el.getBoundingClientRect().top < w.innerHeight) el.classList.add('is-in'); });
    }, 2500);
  }

  /* ---------- scramble / glitch text ---------- */
  var GL = '!<>-_/[]{}=+*^?#01XZ▓▒░';
  function scramble(el) {
    var fin = el.getAttribute('data-final');
    if (fin === null) { fin = el.textContent; el.setAttribute('data-final', fin); }
    if (reduce) { el.textContent = fin; return; }
    clearInterval(el._tx);
    var f = 0, T = Math.min(30, 10 + Math.round(fin.length / 2));
    el.classList.add('tx-glitching');
    el._tx = setInterval(function () {
      var p = f / T, out = '';
      for (var i = 0; i < fin.length; i++) {
        var c = fin.charAt(i);
        if (c === ' ' || c === '\n' || p * fin.length * 1.2 > i + Math.random() * 3) out += c;
        else out += GL.charAt((Math.random() * GL.length) | 0);
      }
      el.textContent = out;
      if (++f > T) { clearInterval(el._tx); el.textContent = fin; el.classList.remove('tx-glitching'); }
    }, 38);
  }
  function setText(el, txt) {
    if (!el) return;
    el.setAttribute('data-final', txt);
    el.textContent = txt;
    scramble(el);
  }

  var heads = $$('.tx-scramble, .sec-h h2, .page-h h1, .pd h1').filter(function (el) { return !el.children.length && el.textContent.trim(); });
  if (hasIO && !reduce) {
    var hio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { scramble(e.target); hio.unobserve(e.target); } });
    }, { threshold: 0.4 });
    heads.forEach(function (el) { hio.observe(el); });
    if (fine) heads.forEach(function (el) { el.addEventListener('pointerenter', function () { scramble(el); }); });
    // idle glitch flicker on a random visible heading
    setInterval(function () {
      if (d.hidden) return;
      var vis = heads.filter(function (el) { var r = el.getBoundingClientRect(); return r.bottom > 0 && r.top < w.innerHeight; });
      if (!vis.length) return;
      var el = vis[(Math.random() * vis.length) | 0];
      el.classList.add('tx-glitching');
      setTimeout(function () { if (!el._tx || el.textContent === el.getAttribute('data-final')) el.classList.remove('tx-glitching'); }, 260);
    }, 3200);
  }

  /* ---------- HERO ---------- */
  $$('[data-txh]').forEach(function (h) {
    var holder = h.parentNode || d;
    var data = [];
    try { data = JSON.parse(holder.querySelector('[data-txh-data]').textContent); } catch (e) { data = []; }
    var obj = h.querySelector('[data-txh-link]');
    var img = h.querySelector('[data-txh-img]');
    var nameEl = h.querySelector('[data-txh-name]');
    var priceEl = h.querySelector('[data-txh-price]');
    var cnt = h.querySelector('[data-txh-count]');
    var bar = h.querySelector('[data-txh-bar]');
    var idx = 0;
    function pad(n) { return (n < 10 ? '0' : '') + n; }

    data.forEach(function (p) { var im = new Image(); im.src = p.i; });

    function show(n) {
      if (!data.length || !obj) return;
      idx = (n + data.length) % data.length;
      var p = data[idx];
      if (!reduce) { obj.classList.remove('is-glitch'); void obj.offsetWidth; obj.classList.add('is-glitch'); }
      setTimeout(function () {
        img.removeAttribute('srcset');
        img.src = p.i;
        img.alt = p.t;
        obj.href = p.u;
      }, reduce ? 0 : 160);
      setText(nameEl, p.t);
      setText(priceEl, p.p);
      if (cnt) cnt.textContent = pad(idx + 1) + ' / ' + pad(data.length);
      if (bar) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
    }
    if (obj) obj.addEventListener('animationend', function (e) { if (e.animationName === 'txGlitch') obj.classList.remove('is-glitch'); }, true);
    if (bar && data.length > 1) bar.addEventListener('animationend', function () { show(idx + 1); });
    var prev = h.querySelector('[data-txh-prev]'), next = h.querySelector('[data-txh-next]');
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });
    if (obj) {
      obj.addEventListener('pointerenter', function () { h.classList.add('is-paused'); });
      obj.addEventListener('pointerleave', function () { h.classList.remove('is-paused'); });
    }
    if (d.hidden !== undefined) d.addEventListener('visibilitychange', function () { h.classList.toggle('is-paused', d.hidden); });

    /* product follows the mouse in 3D */
    if (obj && fine && !reduce) {
      var tx = 0, ty = 0, cx = 0, cy = 0, raf = null;
      var loop = function () {
        cx += (tx - cx) * 0.08; cy += (ty - cy) * 0.08;
        obj.style.setProperty('--ry', (cx * 38).toFixed(2) + 'deg');
        obj.style.setProperty('--rx', (-cy * 24).toFixed(2) + 'deg');
        obj.style.setProperty('--mx', (cx * 34).toFixed(1) + 'px');
        obj.style.setProperty('--my', (cy * 22).toFixed(1) + 'px');
        if (Math.abs(tx - cx) > 0.001 || Math.abs(ty - cy) > 0.001) raf = requestAnimationFrame(loop); else raf = null;
      };
      h.addEventListener('pointermove', function (e) {
        var r = h.getBoundingClientRect();
        tx = (e.clientX - r.left) / r.width - 0.5;
        ty = (e.clientY - r.top) / r.height - 0.5;
        if (!raf) raf = requestAnimationFrame(loop);
      });
      h.addEventListener('pointerleave', function () { tx = 0; ty = 0; if (!raf) raf = requestAnimationFrame(loop); });
    } else if (obj && !reduce) {
      obj.classList.add('is-auto');
    }

    /* electric bolts around the product */
    var svg = h.querySelector('[data-bolts]');
    var inView = true;
    if (hasIO) new IntersectionObserver(function (es) { inView = es[0].isIntersecting; }).observe(h);
    function bolts() {
      if (!svg || reduce || d.hidden || !inView) return;
      var NS = 'http://www.w3.org/2000/svg';
      svg.textContent = '';
      var count = w.innerWidth < 700 ? 6 : 12;
      var hr = h.getBoundingClientRect(), orr = (obj || h).getBoundingClientRect();
      var W = Math.max(1, Math.round(hr.width)), H = Math.max(1, Math.round(hr.height));
      svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
      var ox = orr.left - hr.left + orr.width / 2, oy = orr.top - hr.top + orr.height / 2;
      var R = orr.width * 0.4, U = Math.max(0.6, orr.width / 560);
      function addPath(dstr, sw, delay) {
        var p = d.createElementNS(NS, 'path');
        p.setAttribute('d', dstr);
        p.setAttribute('stroke-width', sw.toFixed(2));
        svg.appendChild(p);
        var len = p.getTotalLength ? p.getTotalLength() : 600;
        p.style.strokeDasharray = len;
        p.style.strokeDashoffset = len;
        p.style.animationDelay = delay.toFixed(2) + 's';
      }
      for (var k = 0; k < count; k++) {
        var a = (k % 2 ? 0 : Math.PI) + (Math.random() - 0.5) * 1.4;
        var x = ox + Math.cos(a) * R, y = oy + Math.sin(a) * R * 0.85;
        var dstr = 'M' + x.toFixed(1) + ' ' + y.toFixed(1);
        var segs = 8 + ((Math.random() * 7) | 0);
        var delay = Math.random() * 0.5;
        for (var s = 0; s < segs; s++) {
          a += (Math.random() - 0.5) * 0.8;
          var step = (22 + Math.random() * 36) * U;
          x += Math.cos(a) * step;
          y += Math.sin(a) * step + (Math.random() - 0.5) * 16 * U;
          dstr += ' L' + x.toFixed(1) + ' ' + y.toFixed(1);
          if (Math.random() < 0.22) {
            var bx = x, by = y, ba = a + (Math.random() < 0.5 ? -1 : 1) * (0.5 + Math.random() * 0.6);
            var bd = 'M' + bx.toFixed(1) + ' ' + by.toFixed(1);
            for (var q = 0; q < 3; q++) { bx += Math.cos(ba) * (14 + Math.random() * 16) * U; by += Math.sin(ba) * (14 + Math.random() * 16) * U; bd += ' L' + bx.toFixed(1) + ' ' + by.toFixed(1); }
            addPath(bd, 0.7 + Math.random() * 0.6, delay + 0.15);
          }
        }
        addPath(dstr, 1 + Math.random() * 1.6, delay);
      }
    }
    bolts();
    if (!reduce) setInterval(bolts, 2800);
  });

  /* ---------- DETAILS parallax ---------- */
  var dets = $$('[data-txd]');
  if (dets.length && !reduce) {
    var tick = false;
    var par = function () {
      dets.forEach(function (el) {
        var r = el.getBoundingClientRect();
        var p = ((r.top + r.height / 2) - w.innerHeight / 2) / (w.innerHeight / 2 + r.height / 2);
        p = Math.max(-1, Math.min(1, p));
        el.style.setProperty('--p', p.toFixed(3));
      });
      tick = false;
    };
    w.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(par); } }, { passive: true });
    par();
  }
})();
